import {
  GET_COMPETENCY_INQUIRY,
  GET_COMPETENCY_LIB,
  GET_COP_LIST,
  GET_CUSTOM_MANAGEMENT,
  GET_DETAIL_COMPANY,
  GET_LIST_LEVEL_DESCRIPTION,
  GET_LIST_MEMBER,
  GET_LIST_SKILL_GROUP,
  GET_LIST_SUB_SKILL_GROUP,
  GET_DETAIL_COMPETENCY,
  GET_LIST_SUB_SKILL_GROUP_MULTIPLE,
  GET_UPDATE_SUB_SKILL_GROUP_MULTIPLE,
} from 'redux/actions/company';

const initialState = {
  list: [],
  detail: '',
  cop: '',
  custom_management: '',
  competency_lib: [],
  listLevelDesc: [],
  competency_inquiry: [],
  skill_group_list: [],
  sub_skill_group_list: [],
  detail_comptency: [],
  sub_skill_group_list_multiple: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LIST_MEMBER: {
      return {
        ...state,
        list: payload,
      };
    }
    case GET_DETAIL_COMPANY: {
      return {
        ...state,
        detail: payload,
      };
    }
    case GET_CUSTOM_MANAGEMENT: {
      if (payload.updateData === false) {
        state.custom_management.unshift(payload.data);
        return state;
      }
      if (payload.updateData === true) {
        if (payload.data.status === 'delete') {
          state.custom_management.splice(0, payload.ids + 1);
        } else {
          state.custom_management[payload?.id] = {
            ...payload.data,
          };
        }
        return state;
      }
      return {
        ...state,
        custom_management: payload.data,
      };
    }
    case GET_COP_LIST: {
      if (payload?.insertData) {
        state.cop.splice(0, 0, payload.data);
        return state;
      }
      if (payload?.updateData) {
        if (payload.status === 'inactive') {
          state.cop.splice(0, payload.id + 1);
        } else {
          state.cop[payload.id] = {
            ...payload.data,
            company_cust_param_id: payload.cust_id,
          };
        }
        return state;
      }

      return {
        ...state,
        cop: payload,
      };
    }
    case GET_COMPETENCY_LIB: {
      if (payload.id !== undefined && payload.id !== null) {
        const temp = { ...state.competency_lib };
        temp.data[payload.id] = {
          ...payload.data,
          competency_detail: payload.data.detail,
        };
        return {
          ...state,
          competency_lib: temp,
        };
      }
      if (payload.create) {
        const tempdata = {
          ...payload.data,
          competency_detail: payload.data.detail,
        };
        const temp = { ...state.competency_lib };
        temp.data.splice(0, 0, tempdata);
        return {
          ...state,
          competency_lib: temp,
        };
      }
      return {
        ...state,
        competency_lib: payload,
      };
    }
    case GET_LIST_LEVEL_DESCRIPTION: {
      return {
        ...state,
        listLevelDesc: payload,
      };
    }
    case GET_COMPETENCY_INQUIRY: {
      return {
        ...state,
        competency_inquiry: payload.datas.data,
      };
    }
    case GET_LIST_SKILL_GROUP: {
      return {
        ...state,
        skill_group_list: payload.data,
      };
    }
    case GET_LIST_SUB_SKILL_GROUP: {
      return {
        ...state,
        sub_skill_group_list: payload.data,
      };
    }
    case GET_DETAIL_COMPETENCY: {
      return {
        ...state,
        detail_comptency: payload.data.data,
      };
    }
    case GET_LIST_SUB_SKILL_GROUP_MULTIPLE: {
      return {
        ...state,
        sub_skill_group_list_multiple: payload,
      };
    }
    case GET_UPDATE_SUB_SKILL_GROUP_MULTIPLE: {
      const { index, list } = payload;
      const newList = [...state.sub_skill_group_list_multiple];
      newList[index] = list;
      return {
        ...state,
        sub_skill_group_list_multiple: newList,
      };
    }
    default:
      return state;
  }
};
